/**
 * /templates route — renders the shared MessageTemplatesPanel.
 * The panel also mounts inside Settings → Templates tab.
 */
import MessageTemplatesPanel from "./settings/MessageTemplatesPanel";

export default function MessageTemplates() {
    return (
        <div className="space-y-6" data-testid="templates-page">
            <div>
                <h1 className="text-2xl md:text-3xl font-display font-semibold tracking-tight">Templates</h1>
                <p className="text-sm text-muted-foreground mt-1">Reusable SMS &amp; email templates. Campaigns and Workflow Automation both select from this library.</p>
            </div>
            <MessageTemplatesPanel />
        </div>
    );
}
